import React, { useEffect, useState } from 'react'
import RightSideDetails from "../global/rightSideDetails";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import Select from 'react-select';
import ImageCropper from '../global/imageCropper';
import AddContactModal from './AddContactModal';
import AddDocumentModal from './AddDocumentModal';
import { uploadFileList, uploadPublicFile } from '../api/fileAPI';
import { addCaddyDocuments, deleteCaddyDocument, getCaddyContactByCaddyID, getCaddyDocumentByCaddyID, getCaddyMasterAll, postCaddyMaster } from '../api/caddyAPI';

const CaddyMaster = (props) => {

    const [caddy,               setCaddy]               = useState({Active: 'Y'});
    const [caddyList,           setCaddyList]           = useState([]);
    const [rightSideDetails,    setRightSideDetails]    = useState(false);
    const [photoBlob,           setPhotoBlob]           = useState(null);
    const [cropperData,         setCropperData]         = useState(null);
    const [contactList,         setContactList]         = useState([]);
    const [deletedContactList,  setDeletedContactList]  = useState([]);
    const [deletedDocumentList, setDeletedDocumentList] = useState([]);
    const [documentList,        setDocumentList]        = useState([]);
    const [showContactModal,    setShowContactModal]    = useState(false);
    const [showDocumentModal,   setShowDocumentModal]   = useState(false);
    const [isInit,              setIsInit]              = useState(true);

    useEffect(() => {         
        props.title("Caddy Master", "caddy-master")
        fetchCaddyMaster();
    }, []);

    useEffect(() => {
        if (rightSideDetails) {
            Config.Core.OpenDrawer()
        } else {
            setCaddy({Active: 'Y'})
            setContactList([])
            setDocumentList([])
            setDeletedDocumentList([])
            setDeletedContactList([])
            setPhotoBlob(null)
        }
    }, [rightSideDetails])

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [caddyList])

    const escapeHTML = (str = '') => {
        return String(str)
               .replace(/&/g, '&amp;')
               .replace(/</g, '&lt;')
               .replace(/>/g, '&gt;')
               .replace(/"/g, '&quot;')
               .replace(/'/g, '&#39;');
    };

    const updateCaddyDetails = (field, value) => {   
        setCaddy((d) => {
            return { ...d, [field]: value };
        });
    };

    const openBannerCropper = () => {
        setCropperData({
            imageRatio  : { width : 200, height : 200},
            dataHandler : (val) =>  setPhotoBlob(val),
            header : 'Upload Photo'
        })
    }

    const deleteContactHandler = (index) => {
        const contact = contactList.find((_, i) => i == index)
        if (contact && contact.ID) {
            setDeletedContactList(d => [...d, contact.ID])
        }
        const updatedContactList = contactList.filter((_, i) => i !== index);
        setContactList(updatedContactList);
    }

    const deleteDocumentHandler = (index) => {
        const document = documentList.find((_, i) => i == index)
        if (document && document.ID) {
            setDeletedDocumentList(d => [...d, document.ID])
        }
        const updatedDocumentList = documentList.filter((_, i) => i !== index);
        setDocumentList(updatedDocumentList);
    }

    const fetchCaddyMaster = async() => {
        try {
            const caddyMaster =  await getCaddyMasterAll();
            isInit ? setIsInit(false) : $('#tblCaddy').KTDatatable().destroy();
            setCaddyList(caddyMaster)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const fetchCaddyContactByCaddyID = async(caddyID) => {
        try {
            const contact =  await getCaddyContactByCaddyID(caddyID);
            setContactList(contact)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const fetchCaddyDocumentByCaddyID = async(caddyID) => {
        try {
            const doc = await getCaddyDocumentByCaddyID(caddyID);
            setDocumentList(doc)
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    function fillDataTable() {

        const dataTable = $('#tblCaddy').KTDatatable({
            data: {
                saveState: false,
                source: caddyList,
                pageSize: 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: true,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Name',
                    title: 'Name',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="event-thumbail" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.Name.substring(0, 1)}</div>`}
                                </div>
                                <div class="kt-user-card-v2__details text-clip">
                                    <span class="kt-user-card-v2__name text-clip"> ${escapeHTML(row.Name)} </span> 
                                </div>
                            </div>`
                    },
                    width: 200,
                },
                {
                    field: 'CaddyNumber',
                    title: 'Caddy Number',
                    width: 120,
                    template: function (row) { return `${escapeHTML(row.Name)}` }
                },
                {
                    field: 'Mobile',
                    title: 'Mobile',
                    width: 100,
                },
                {
                    field: 'Active',
                    title: 'Active',
                    template: function (row) {
                        if (row.Active == 'Y') {
                            return '<span class="kt-badge kt-badge--success kt-badge--pill  padding-lr20 padding-tb10">Yes</span>'
                        } else {
                            return '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr20 padding-tb10"> No </span>'
                        }
                    },
                    width: 100,
                },
            ]
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblCaddy .kt-datatable__table').addClass('overflow-x-auto');

        dataTable.on('click', 'tr', function () {
            const index = ($("tr").index(this) - 1);
            if (dataTable.dataSet[index]) {
                if (dataTable.dataSet[index]) {
                    fetchCaddyContactByCaddyID(dataTable.dataSet[index].ID)
                    fetchCaddyDocumentByCaddyID(dataTable.dataSet[index].ID)
                }
                setCaddy(dataTable.dataSet[index]);
                setRightSideDetails(true);  
            }    
        });

    }

    const addCaddyHandler = async (e) => {
        e.preventDefault()
        const btn = $('#btnSave');
        var form = $('#add-caddy-form');

        form.validate({
            rules: {
                txtName: {
                    required: true
                },
                txtCaddyNumber: {
                    required: true,
                },
            },
            messages: {
                txtName: {
                    required: "Please name"
                },
                txtCaddyNumber: {
                    required: "Please enter caddy number",
                },
            }
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        try {
            let Photo;
            if (photoBlob) {
                const res = await uploadPublicFile(photoBlob, 'Caddy');
                Photo = res.fileName;
            } else {
                if(caddy.Photo) Photo = caddy.Photo.split('/Caddy/')[1];
            }

            const ID = await postCaddyMaster({...caddy, Photo}, contactList, deletedContactList);

            if (caddy.ID && deletedDocumentList.length > 0) {
                await deleteCaddyDocument(deletedDocumentList)
            }
            
            if (documentList && documentList.length > 0) {
                const filteredDocumentList = documentList.filter(d => !d.hasOwnProperty('ID'))
                let fileList = [];
                if (filteredDocumentList.length > 0) {
                    fileList = await uploadFileList(filteredDocumentList.map(d => d.file), "Document")
                    const postDocuments = [];
                    filteredDocumentList.forEach(document => {
                        postDocuments.push({
                            CaddyID : caddy.ID ? caddy.ID : ID,
                            FileName: document.FileName,
                            File: fileList.find(f => f.originalname == document.file.name).filename
                        })
                    })
                    if (postDocuments && postDocuments.length > 0)
                        await addCaddyDocuments(postDocuments)
                }
            }

            swal.fire({
                icon              : 'success',
                titleText         : 'Master Added Successfully',
                showConfirmButton : false,
                timer             : 1500,
            });      
            fetchCaddyMaster()
            helper.StopProcessing(btn);
            closeDrawer();
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }

    const FileHandler = (file) => {
        if (file.ID) {
            openDocument(file)
        } else {
            helper.openFileHandler(file)
        }
    }

    const openDocument = async (d) => {
        const ext = helper.getFileExt(d.File)
        const name = (d.FileName + '.' + ext).replace(/ /g, '_');
        helper.downloadAndOpenFileHandler('Document', d.File, name);
    }

    const closeDrawer = () => {
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
        }, 200);        
    }
    
    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor  padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet ">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input type="text" className="form-control clientSearch" placeholder="Search Caddy..." id="generalSearch" />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button  onClick={() => setRightSideDetails(true)}  type="button" className="btn btn-brand btn-icon-sm text-white d-inline"><i className="la la-plus"></i>New Caddy</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblCaddy" className="kt-datatable table-striped clickable"></div>
                            {rightSideDetails && 
                                <RightSideDetails title="Coach Details" onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form className="kt-form" id="add-caddy-form">
                                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">                                       
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Name <span className="red">*</span></label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <input 
                                                                id="txtName" name="txtName" type="text" 
                                                                value={caddy.Name || ''}
                                                                onChange={(event) => updateCaddyDetails('Name', event.target.value)}
                                                                className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Caddy Number <span className="red">*</span> </label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <input 
                                                                id="txtCaddyNumber" name="txtCaddyNumber" type="text" 
                                                                value={caddy.CaddyNumber || ''}
                                                                onChange={(event) => updateCaddyDetails('CaddyNumber', event.target.value)}
                                                                className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Address</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <textarea 
                                                                id="txtAddress" name="txtAddress" 
                                                                value={caddy.Address || ''}
                                                                onChange={(event) => updateCaddyDetails('Address', event.target.value)}
                                                                className="form-control" rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Mobile</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <input id="txtMobile" name="txtMobile" type="text" 
                                                            value={caddy.Mobile || ''}
                                                            minLength='10'
                                                            maxLength='10'
                                                            onChange={(event) => updateCaddyDetails('Mobile', event.target.value)}
                                                            className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Email </label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <input id="txtEmail" name="txtEmail" type="text" 
                                                                value={caddy.Email || ''}
                                                                onChange={(event) => updateCaddyDetails('Email', event.target.value)}
                                                                className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3"> Photo </label>
                                                        <div className="col-xl-6 col-lg-8">                                                        
                                                            {(!!photoBlob || caddy.Photo) &&(<>
                                                                <img height={150} src={photoBlob ? URL.createObjectURL(photoBlob) : caddy.Photo && (caddy.Photo) }/>
                                                            </>) }
                                                            <p className="mt-3">
                                                                <button id="btn_Logo_Image" type="button" className="btn btn-secondary" onClick={openBannerCropper}>
                                                                {(!!photoBlob || caddy.Photo) ? 'Change Image' : 'Upload Image'}
                                                                </button>
                                                            </p>
                                                            <p className="">(200 W x 200 H pixels)</p>                                                       
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">RFID</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <input 
                                                                id="txtRFID" name="txtRFID" type="text" 
                                                                value={caddy.RFID || ''}
                                                                onChange={(event) => updateCaddyDetails('RFID', event.target.value)}
                                                                className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row" style={{marginBottom: '1rem'}}>
                                                        <label className="col-form-label col-lg-3">Active</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <span className="kt-switch kt-switch--icon">
                                                                <label>
                                                                    <input 
                                                                        id="chkActive" 
                                                                        name="chkActive" 
                                                                        type="checkbox"
                                                                        defaultChecked={caddy.Active && caddy.Active == 'N' ? '' : 'checked'}
                                                                        onChange={(event) => updateCaddyDetails('Active', event.target.checked ? 'Y' : 'N')} 
                                                                    />
                                                                    <span></span>
                                                                </label>
                                                            </span>
                                                        </div>
                                                    </div> 
                                                    <div className="row">
                                                        <div className="col">
                                                            <hr />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row margin-b5">
                                                        <label className="col-form-label col-lg-3">Caddy Contacts </label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className="text-left margin-b10">
                                                                <span id="btnAddContact" type="button" className="btn btn-sm btn-secondary d-inline-block" onClick={() => setShowContactModal(true)}>
                                                                    <i className="fa fa-plus"></i>Add Contact
                                                                </span>
                                                            </div>
                                                            {(contactList && contactList.length > 0) && (
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <table id="table-contact" className="table table-striped table-bordered table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{width: "35%"}}>Contact Name</th>
                                                                                    <th style={{width: "30%"}}>Contact Mobile</th>
                                                                                    <th style={{width: "30%"}}>Contact Email</th>
                                                                                    <th style={{width: "5%"}}>Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {contactList.map((c, i) => (

                                                                                    <tr key={i}>
                                                                                        <td className="contact-name">{c.ContactPersonName}</td>
                                                                                        <td className="contact-mobile">{c.ContactPersonMobile}</td>
                                                                                        <td className="contact-email">{c.ContactPersonEmail}</td>
                                                                                        <td className="contact-delete">
                                                                                            <button 
                                                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10" 
                                                                                                onClick={() => deleteContactHandler(i)}
                                                                                                type="button"><i className="flaticon2-rubbish-bin-delete-button"></i></button>

                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <hr />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row margin-b5">
                                                        <label className="col-form-label col-lg-3">Caddy Documents </label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className="text-left margin-b10">
                                                                <span id="btnAddDocument" type="button" className="btn btn-sm btn-secondary d-inline-block" onClick={() => setShowDocumentModal(true)}>
                                                                    <i className="fa fa-plus"></i>Add Document
                                                                </span>
                                                            </div>
                                                            {(documentList && documentList.length > 0) && (
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <table id="table-contact" className="table table-striped table-bordered table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th style={{width: "60%"}}>Document Name</th>
                                                                                    <th style={{width: "40%"}}>Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {documentList.map((c, i) => (

                                                                                    <tr key={i}>
                                                                                        <td className="contact-name">{c.FileName}</td>
                                                                                        <td className="contact-delete">

                                                                                            <button 
                                                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10" 
                                                                                                onClick={() => FileHandler(c.ID ? c : c.file)}
                                                                                                type="button"><i className="flaticon-eye"></i></button>
                                                                                            <button 
                                                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10" 
                                                                                                onClick={() => deleteDocumentHandler(i)}
                                                                                                type="button"><i className="flaticon2-rubbish-bin-delete-button"></i></button>

                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-7 ml-lg-auto">
                                                        <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addCaddyHandler}>Save</button>
                                                        <button id="btnCancel" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {cropperData && (
                <ImageCropper
                    show           = { cropperData }
                    header         = { cropperData.header }   
                    imageRatio     = { cropperData.imageRatio }
                    dataHandler    = { cropperData.dataHandler }
                    onDismissModal = {() => setCropperData(null) }
                />
            )}
            {showContactModal && (
                <AddContactModal
                    show={showContactModal}
                    setContactList={setContactList}
                    onDismissModal={() => setShowContactModal(false)}
                />
            )}
            {showDocumentModal && (
                <AddDocumentModal
                    show={showDocumentModal}
                    setDocumentList={setDocumentList}
                    onDismissModal={() => setShowDocumentModal(false)}
                />
            )}
        </>
    )
}

export default CaddyMaster